const navLinks = (
  isMobile: boolean,
  isDashboard: boolean,
  isAdmin?: boolean,
): Array<Object> => {
  const links = isDashboard
    ? [
        // { titel: "Dashboard", link: "dashboard" },
        { titel: "My Team", link: "dashboard/my-team" },
        { titel: "Profile", link: "dashboard/profile" },
        { titel: "Matches", link: "dashboard/matches" },
        { titel: "Refereeing", link: "dashboard/refereeing" },
        { titel: "Settings", link: "dashboard/settings" },
      ]
    : [
        { titel: "Teams", link: "/teams" },
        { titel: "Scorer", link: "/TopScorer" },
        { titel: "Matches", link: "/matches" },
        { titel: "Table", link: "/table" },
        { titel: "Rules", link: "/rules" },

        /*{
      titel: "About Us", link: "/AboutUs"
  }
    */
      ];
  if (isAdmin && isDashboard) {
    links.push({ titel: "Seasons", link: "dashboard/seasons" });
  }
  return links;
};

export default navLinks;
